import { render } from "./MenuElementLevel2.pug?vue&type=template&id=6048c799&lang=pug"
import script from "./MenuElementLevel2.js?vue&type=script&lang=js"
export * from "./MenuElementLevel2.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__